/**
 * A dialog component to call the thin-out-sites algorithm.
 */

import loaderIcon from '../../../../images/loader.svg';
import ThinOutWorker from 'worker-loader!../../../utils/thin-out-sites/thin-out-sites-worker';

const ID = 'aims_msp_selected-sites-panel_thin-out-sites-dialog';
const TEMPLATE = `
<div id="${ID}" class="modal process-dialog" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Thin Out Sites</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      </div>
      <div class="modal-footer">
      </div>
    </div>
  </div>
</div>
`;

const TEMPLATE_BODY_FORM = `
        <div class="form-group row">
          <label for="selectedSites" class="col-sm-3 col-form-label">Selected sites</label>
          <div class="col-sm-9">
            <textarea id="selectedSites" class="form-control-plaintext" readonly>No sites selected.</textarea>
          </div>
        </div>
        <div class="form-group row">
          <label for="selectedCriteria" class="col-sm-3 col-form-label">Selected criteria</label>
          <div class="col-sm-9">
            <textarea id="selectedCriteria" class="form-control-plaintext" readonly>No criteria selected.</textarea>
          </div>
        </div>
        <div class="form-group row">
          <label for="selectAlgorithm" class="col-sm-3 col-form-label">Algorithm</label>
          <div class="col-sm-9">
            <select class="form-control" id="selectAlgorithm"></select>
          </div>
        </div>
        <div class="form-group row">
          <label for="inputThreshold" class="col-sm-3 col-form-label">Number of sites to remove</label>
          <div class="col-sm-9">
            <input type="number" class="form-control" id="inputThreshold" value="2">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Must-have sites</label>
          <div class="col-sm-9">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="cbMustHaveSites">
              <label class="form-check-label" for="cbMustHaveSites">Keep must-have sites</label>
            </div>
          </div>
        </div>
`;

const TEMPLATE_FOOTER_FORM =  `
        <button type="button" class="btn btn-danger btn-thin-out-sites">Start Thinning Out</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
`;

const TEMPLATE_BODY_PROCESSING = `
        <p>Thinning out sites ...</p>
        <div class="loader"><span class="current-progress">0</span></div>
        <div class="log"></div>
`;

const TEMPLATE_FOOTER_PROCESSING =  `
        <button type="button" class="btn btn-primary btn-minimise-maximise">Minimise</button>
        <button type="button" class="btn btn-primary btn-show-current-sample">Show current sample</button>
        <button type="button" class="btn btn-primary btn-stop">Stop</button>
`;

const TEMPLATE_BODY_RESULTS = `
        <p>Removed site and score per iteration:</p>
        <div class="results"><textarea></textarea></div>
`;

const TEMPLATE_FOOTER_RESULTS =  `
        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
`;

export default class ThinOutSitesDialog {

  /**
   * Constructor
   * @param datasetsModel
   * @param selectedSitesModel
   * @param referenceSitesHashModel
   * @param algorithmsModel
   * @param variablesModel
   * @param siteDistanceModel
   */
  constructor(datasetsModel, selectedSitesModel, referenceSitesHashModel, algorithmsModel, variablesModel, siteDistanceModel) {

    // Cache references.
    this._datasetsModel = datasetsModel;
    this._selectedSitesModel = selectedSitesModel;
    this._referenceSitesHashModel = referenceSitesHashModel;
    this._algorithmsModel = algorithmsModel;
    this._variablesModel = variablesModel;
    this._siteDistanceModel = siteDistanceModel;

    // Worker
    this._worker = null;

    // Array of sample, removed sites and scores per iteration
    this._results = [];

    // Create element
    this._$modalEl = $(TEMPLATE);
    this._$modalElBody = this._$modalEl.find('.modal-body');
    this._$modalElBody.html(TEMPLATE_BODY_FORM);
    this._$modalElFooter = this._$modalEl.find('.modal-footer');
    this._$modalElFooter.html(TEMPLATE_FOOTER_FORM);

    // Add dynamic content
    this._createDynamicFormContent();

    // Insert the template to render the list.
    $('body').append(this._$modalEl);

    // Display the dialog.
    this._$modalEl.modal({
      backdrop: 'static',
      keyboard: false
    });

    // Clean up after close.
    this._$modalEl.on('hidden.bs.modal', () => {
      if (this._worker !== null) {
        this._worker.terminate();
      }
      this._$modalEl.remove();
    });

    // Add an event handler to buttons.
    this._$modalElFooter.find('.btn-thin-out-sites').click(this._handleThinOutSitesClick.bind(this));
  }

  /**
   * Create the dynamic part of the modal box body content, like a dynamic list of for all selected criteria
   * @private
   */
  _createDynamicFormContent() {
    const selectedSites =  [];
    Object.keys(this._selectedSitesModel.getData()).forEach(key => {
      selectedSites.push(this._referenceSitesHashModel.getData()[key].name);
    });
    if (selectedSites.length > 0) {
      this._$modalEl.find('#selectedSites').val(selectedSites.join('\n'));
    }

    const selectedCriteria =  [];
    $('table#calculations tbody tr').get().forEach(row => {
      if ($(row).find('td.criteria-active input:checked').length === 1) {
        selectedCriteria.push($(row).data('name') + ' (weight: ' + $(row).find('td.criteria-weight input').val() + ')');
      }
    });
    if (selectedCriteria.length > 0) {
      this._$modalEl.find('#selectedCriteria').val(selectedCriteria.join('\n'));
    }

    const $selectAlgorithm = this._$modalEl.find('#selectAlgorithm');
    this._algorithmsModel.getItems().forEach((_algorithm) => {
      $selectAlgorithm.append(`<option value="${_algorithm.id}">${_algorithm.name}</option>`);
    });
  }

  /**
   * Handle click on the start-thinning-out-button
   * @param event
   * @private
   */
  _handleThinOutSitesClick(event) {
    this._$modalElBody = this._$modalEl.find('.modal-body');
    const algorithm = this._$modalElBody.find('select#selectAlgorithm').val();
    const thresholdStr = this._$modalElBody.find('input#inputThreshold').val();
    const useMustHaveSites = this._$modalElBody.find('input#cbMustHaveSites').prop('checked');

    this._$modalElBody.html(TEMPLATE_BODY_PROCESSING);

    const $loader = this._$modalElBody.find('.loader');
    $loader.css('background-image', 'url(' + loaderIcon + ')');

    const selectedCriteria = this._buildCriteriaArray('spatialReconstruction');
    const categoryFairnessVariables = this._buildCriteriaArray('categoryFairness');
    const historicWeightingCriteria = this._buildCriteriaArray('historicalWeighting');

    this._worker = new ThinOutWorker();
    this._worker.postMessage({
      'algorithm': algorithm,
      'selectedVariables': selectedCriteria,
      'categoryFairnessVariables': categoryFairnessVariables,
      'historicWeightingCriteria': historicWeightingCriteria,
      'activeDataset': this._datasetsModel.getActiveDataset(),
      'referenceSitesHash': this._referenceSitesHashModel.getData(),
      'siteDistanceData': this._siteDistanceModel.getData(),
      'initialSample': Object.keys(this._selectedSitesModel.getData()),
      'threshold': parseInt(thresholdStr),
      'useMustHaveSites': useMustHaveSites
    });

    this._worker.onmessage = (event) => {
      this._updateCurrentProgress(event);
    };

    this._$modalElFooter = this._$modalEl.find('.modal-footer');
    this._$modalElFooter.html(TEMPLATE_FOOTER_PROCESSING);
    this._$modalElFooter.find('.btn-minimise-maximise').click(ThinOutSitesDialog._handleMinimiseMaximiseClick.bind(this));
    this._$modalElFooter.find('.btn-show-current-sample').click(this._handleShowCurrentSampleClick.bind(this));
    this._$modalElFooter.find('.btn-stop').click(this._handleStopClick.bind(this));
  }

  /**
   *
   * @param type
   * @return {Array}
   * @private
   */
  _buildCriteriaArray(type) {
    const criteriaArray = [];
    $(`table#calculations tbody tr[data-type="${type}"]`).get().forEach(row => {
      if ($(row).find('td.criteria-active input:checked').length === 1) {
        const weight = $(row).find('td.criteria-weight input').val();

        const criteria = this._variablesModel.getItems().find(item => item.id === $(row).data('aims-criteria-key'));
        if (criteria) {
          criteria.weight = parseFloat(weight) > 0 ? parseFloat(weight) : 0;
          criteriaArray.push(criteria)
        } else {
          criteriaArray.push({
            id:  $(row).data('aims-criteria-key'),
            weight: parseFloat(weight) > 0 ? parseFloat(weight) : 0
          });
        }
      }
    });
    return criteriaArray;
  }

  /**
   * Handle click on the start-optimising-button
   * @param event
   * @private
   */
  static _handleMinimiseMaximiseClick(event) {
    const $modal = $('#aims_msp_selected-sites-panel_optimise-dialog');
    $modal.toggleClass('minimised');
    if ($modal.hasClass('minimised')) {
      $modal.find('.btn-minimise-maximise').html('Maximise');
    } else {
      $modal.find('.btn-minimise-maximise').html('Minimise');
    }
    $('.modal-backdrop').toggle();
  }

  /**
   * Handle click on the start-optimising-button
   * @param event
   * @private
   */
  _handleShowCurrentSampleClick(event) {
    this._selectedSitesModel.setData(this._results[this._results.length - 1].sample);
  }

  /**
   * Handle click on the start-optimising-button
   * @param event
   * @private
   */
  _handleStopClick(event) {
    this._$modalElBody.find('.loader').find('.current-progress').html('Stopped, updating display');
    this._finish();
  }

  /**
   * Show new progress to user
   * @param event
   * @private
   */
  _updateCurrentProgress(event) {
    const message = event.data;

    // @ToDo remove strings, use variables from thin-out-sites
    switch (message.type) {
      case 'app.utils.thin-out-sites.iteration-started':
        this._$modalElBody.find('.loader').find('.current-progress').html('Iteration: ' + message.data.iteration);
        break;
      case 'app.utils.thin-out-sites.iteration-result-available':
        if (Array.isArray(message.data.sample)) {
          const resultSample = {};
          const _referenceSites = this._referenceSitesHashModel.getData();
          Object.keys(_referenceSites).forEach((_id) => {
            const index = message.data.sample.indexOf(_id);
            if (index >= 0) {
              // Reference site found in the list of uploaded ids.
              resultSample[_id] = {
                id: _referenceSites[_id].id,
                latitude: _referenceSites[_id].lat,
                longitude: _referenceSites[_id].lon
              };
              message.data.sample.splice(index, 1);
            }
          });

          const result = {
            iteration: message.data.iteration,
            sample: resultSample,
            removedSites: message.data.removedSites,
            currentRemovedSite: message.data.currentRemovedSite,
            score: message.data.score
          };

          const logDiv = this._$modalElBody.find('.log');
          logDiv.append(
            'Iteration ' + message.data.iteration + ' score: ' + message.data.score.toFixed(6) +
            ((this._results.length > 0 && this._results[this._results.length - 1].score !== message.data.score) ? ' <<< ' + (message.data.score - this._results[this._results.length - 1].score).toFixed(6) : '') +
            '<br>'
          );
          logDiv.animate({scrollTop: logDiv.prop('scrollHeight')});

          this._results.push(result);
        }
        break;
      case 'app.utils.thin-out-sites.terminated':
      default:
        this._$modalElBody.find('.loader').find('.current-progress').html('Finished, updating display');
        this._finish();
    }
  }

  /**
   * Update selected sites model and close modal
   * @private
   */
  _finish() {
    if (this._results.length > 0) {
      this._selectedSitesModel.setData(this._results[this._results.length - 1].sample);
    }
    this._worker.terminate();
    this._worker = null;

    this._$modalElBody.html(TEMPLATE_BODY_RESULTS);

    const resultsCsv = this._results.map(result => result['currentRemovedSite'] + "," + result['score'] + ",").join('\n');
    this._$modalElBody.find('.results textarea').html(resultsCsv);


    this._$modalElFooter = this._$modalEl.find('.modal-footer');
    this._$modalElFooter.html(TEMPLATE_FOOTER_RESULTS);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/selected-sites-panel/dialogs/thin-out-sites-dialog.js